import { render, staticRenderFns } from "./ChangePort.vue?vue&type=template&id=f7c97ab4&scoped=true"
import script from "./ChangePort.vue?vue&type=script&lang=js"
export * from "./ChangePort.vue?vue&type=script&lang=js"
import style0 from "./ChangePort.vue?vue&type=style&index=0&id=f7c97ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c97ab4",
  null
  
)

export default component.exports